import React from 'react';
import { ArrowRight } from 'lucide-react';
import ProductCard from './ProductCard';
import './ProductCard.css';

const ProductGrid = ({ 
  title = "Best Selling Products", 
  typeFilter = null, 
  onAddToCart, 
  onToggleWishlist,
  id = "best-sellers",
  lightBg = true,
  products = []
}) => {
  // Filter products by type if typeFilter is set
  const displayedProducts = typeFilter 
    ? products.filter(product => product.type === typeFilter)
    : products;

  return (
    <section id={id} className={`section-wrapper ${lightBg ? 'products-bg-wrapper' : 'white-bg-wrapper'}`}>
      <div className="container">
        {/* Header */}
        <div className="section-header">
          <div className="section-title-wrapper">
            <h2 className="section-title">{title}</h2>
            <div className="title-divider" />
          </div>
          <a href={`#all-${typeFilter || 'products'}`} className="view-all-btn">
            <span>View All {title}</span>
            <ArrowRight size={14} />
          </a>
        </div>

        {/* Products Grid */}
        <div className="product-grid">
          {displayedProducts.map((product) => (
            <ProductCard
              key={product.id}
              product={product}
              onAddToCart={onAddToCart}
              onToggleWishlist={onToggleWishlist}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductGrid;
